import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "@/lib/auth";
import { mustSetPassword } from "@/types/auth";

export function ProtectedRoute() {
  const { user, isLoading, isStaff } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-whart-bg text-sm text-neutral-500">
        Chargement…
      </div>
    );
  }

  if (!user || !isStaff) {
    const redirectTo = `${location.pathname}${location.search}`;
    const params = new URLSearchParams();
    if (redirectTo && redirectTo !== "/login") {
      params.set("redirectTo", redirectTo);
    }
    if (!isStaff && user) {
      params.set("error", "unauthorized");
    }
    const search = params.toString();
    return <Navigate to={search ? `/login?${search}` : "/login"} replace />;
  }

  if (mustSetPassword()) {
    return <Navigate to="/set-password" replace />;
  }

  return <Outlet />;
}
